import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AuthService } from './auth-service';
import { SnackbarService } from './snackbar.service';

const CLAIMS_CHANGED_HEADER = 'X-Claims-Changed';

@Injectable()
export class ClaimsChangedInterceptor implements HttpInterceptor {
  private isReloading = false;

  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        next: event => {
          if (event instanceof HttpResponse) {
            this.reloadIfClaimsChanged(event.headers);
          }
        },
        error: error => {
          if (error instanceof HttpErrorResponse) {
            this.reloadIfClaimsChanged(error.headers);
          }
        },
      })
    );
  }

  private reloadIfClaimsChanged(headers: HttpHeaders): void {
    if (headers.get(CLAIMS_CHANGED_HEADER) !== 'true' || this.isReloading) return;
    this.isReloading = true;
    this.injector
      .get(AuthService)
      .reloadUserClaims()
      .catch(() => this.injector.get(SnackbarService).showError('errors.serverCommunicationError'))
      .finally(() => (this.isReloading = false));
  }
}
